import Swiper from 'swiper';
import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

export const initPortfolioCarousel = (): void => {
  const swiperEl = document.querySelector('.mySwiper');
  if (!swiperEl) return;

  new Swiper('.mySwiper', {
    // Swiper options
    modules: [EffectCoverflow, Pagination, Autoplay],
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    initialSlide: 1, // Start with the middle slide (if 3 items)
    observer: true,
    observeParents: true,

    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
};
